import BaseComponent from '../App/base';

export default class Test extends BaseComponent {
  constructor(selector, store) {
    super(selector, store, 'test');

    this.$result = this.$selector.find('.js-test');
  }

  render() {
    this.$result.text(this.state.test);
  }
}
